import { useEffect } from "react";
import InAppSpy from "inapp-spy";
import { useToastMessage } from "./useToastMessage";
import { useModifiedTranslation } from "./useModifiedTranslation";

/**
 * inAppブラウザでのみ getUserMedia を試み、マイクが取れなかった場合に
 * 外部ブラウザで開き直すよう案内するトーストを表示する。
 * 通常ブラウザでは何もしない。
 */
export function useInAppMicCheck(): void {
  const toastMessage = useToastMessage();
  const t = useModifiedTranslation();

  useEffect(() => {
    if (!InAppSpy().isInApp) return;

    const notify = (): void => {
      // 案内は読了に時間がかかるため自動で消さず、ユーザーが閉じるまで表示する。
      toastMessage(t("Recording.inAppBrowserMicDenied"), "warning", {
        duration: null,
      });
    };

    if (!navigator.mediaDevices?.getUserMedia) {
      notify();
      return;
    }

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        // 権限プロンプトを出すためだけに取得しているので、即座に停止する
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((err) => {
        if (err instanceof DOMException && err.name === "NotAllowedError") {
          notify();
        }
      });
  }, [toastMessage, t]);
}
